import { ProductAvailabilityTemplateUpdatePage } from '@/features/product-availability-template/pages/ProductAvailabilityTemplateUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-availability-template/$id/update',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_availability_template.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAvailabilityTemplateUpdatePage,
})
